// UI drafts are adapters, never a new persisted content model.
const escapeHtml = (value) =>
  String(value).replace(
    /[&<>"']/g,
    (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[
        c
      ])
  );
export function toLifeObject(draft, original = {}) {
  const retained = (original.content || []).filter(
    (item) =>
      !['lifetap-note', 'lifetap-list', 'lifetap-photo'].includes(item.label)
  );
  return {
    name: draft.title.trim(),
    content: [
      ...retained,
      ...draft.photos.map((photo) => ({
        type: 'image',
        ...(photo.assetId ? { assetId: photo.assetId } : { url: photo.url }),
        label: 'lifetap-photo',
      })),
      ...(draft.note.trim()
        ? [{ type: 'text', body: draft.note.trim(), label: 'lifetap-note' }]
        : []),
      ...(draft.items.length
        ? [
            {
              type: 'html',
              body: `<ul>${draft.items
                .map((item) => `<li>${escapeHtml(item)}</li>`)
                .join('')}</ul>`,
              label: 'lifetap-list',
            },
          ]
        : []),
    ],
  };
}
export function fromLifeObject(object = {}) {
  const content = object.content || [];
  const list = content.find((item) => item.label === 'lifetap-list');
  const doc = new DOMParser().parseFromString(list?.body || '', 'text/html');
  return {
    title: object.name || '',
    note: content.find((item) => item.label === 'lifetap-note')?.body || '',
    items: Array.from(doc.querySelectorAll('li')).map(
      (item) => item.textContent
    ),
    photos: content
      .filter((item) => item.label === 'lifetap-photo')
      .map((item, index) => ({
        id: item.assetId || `${index}:${item.url}`,
        assetId: item.assetId,
        url: item.assetPreviewUrl || item.url,
        alt: object.name || 'Photo',
      })),
    remaining: content.filter(
      (item) =>
        !['lifetap-note', 'lifetap-list', 'lifetap-photo'].includes(item.label)
    ),
  };
}
